import { render, staticRenderFns } from "./EditMerchant.vue?vue&type=template&id=909fbbb6"
import script from "./EditMerchant.vue?vue&type=script&lang=js"
export * from "./EditMerchant.vue?vue&type=script&lang=js"
import style0 from "./EditMerchant.vue?vue&type=style&index=0&id=909fbbb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports